// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SuitableConnectionAreasVO')
export class SuitableConnectionAreasVO {

  @JsonProperty('article', 'ArticleVOConverter', true)
  public article: ArticleVO = undefined;
  @JsonProperty('connectionAreas', '[ConnectionAreaVO]')
  public connectionAreas: ConnectionAreaVO[] = undefined;

  public static create(article: ArticleVO = null, connectionAreas: ConnectionAreaVO[] = null): SuitableConnectionAreasVO {
    const suitableConnectionAreasVO: SuitableConnectionAreasVO = new SuitableConnectionAreasVO();
    suitableConnectionAreasVO.article = article;
    suitableConnectionAreasVO.connectionAreas = connectionAreas;
    return suitableConnectionAreasVO;
  }
}
